import styled from "styled-components";
import { theme } from '../../../theme'
import { MdHelpOutline, MdDone } from "react-icons/md";
import { Button } from "../../button";
import { Link } from "react-router-dom";

const Item = styled.div`
  display: flex;
  align-items: center;
    padding: 1.9rem 3.7rem 1.9rem 1.2rem;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
    justify-content: space-between;
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`


const TextContainer = styled.div`
    margin-left:1.9rem;
    width: 14rem;
    .main-header {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .date {
        font-size: 1.2rem;
        color: #979797;
    }
`

const StyledSpan = styled.span`
    font-weight: 500;
    font-size: 1rem;
    color: #979797;
    text-transform: uppercase;
`
const LongTextContainer = styled.div`
@media only screen and (max-width: 768px) {
    display: none;
}

    p {
        font-weight: 400;
        font-size: 1.2rem;
        color: #979797;
        white-space: nowrap; 
        width: 35.6rem; 
        overflow: hidden;
        text-overflow: ellipsis; 
    }
`

const ImageTextContainer = styled.div`
    display: flex;
    align-items: center;
`

const SupportTicketItem = ({ category, title, longText, date }) => {
    const isAdmin = window.location.pathname.includes('admin')
    return (
        <Item>
            <ImageTextContainer>
                <ImageContainer>
                    {category === 'closed' ? <MdDone /> : <MdHelpOutline />}
                </ImageContainer>
                <TextContainer>
                    <p className="main-header">{title}</p>
                    <p className="date">{date}</p>
                </TextContainer>
            </ImageTextContainer>

            <LongTextContainer>
                <p>{longText}</p>
            </LongTextContainer>
            {isAdmin ? (
                <Link to="/admin/support/ticket">
                    <Button size="small" variant="secondary" disabled={category === 'closed'}>{category}</Button>
                </Link>
            ) : (
                <Button size="small" variant="secondary" disabled={category === 'closed'}>{category}</Button>
            )}


        </Item>
    )
}

export default SupportTicketItem
